import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import BookingSummary from './BookingSummary'
import SetTravelers from './Steps/SetTravelers'
import ReviewPay from './Steps/ReviewPay'
import StepZilla from 'react-stepzilla'
import { translate } from 'react-i18next'
import { Loading } from '../UI'
import _ from 'lodash'
import config from '../../config'

import CREATE_BOOKING_QUERY from './../../graphql/Activity/CreateTourBooking.graphql'
import USER_QUERY from './../../graphql/User.graphql'
import LOCAL_TOUR_QUERY from './../../graphql/Activity/LocalTour.graphql'

class ActivityBookingSteps extends Component {
  constructor(props) {
    super(props)
    this.updateState = this.updateState.bind(this)
    this.state = {
      planLocations: [
        {
          country: 'Croatia'
        },
        {
          country: 'Italy'
        }
      ],
      travelers: [],
      categories: [],
      categoryNames: [],
      requiredServices: [],
      serviceNames: [],
      startDate: new Date(),
      endDate: new Date(2018, 10, 1)
    }
  }

  componentWillReceiveProps(nextProps) {
    this.user = nextProps.user

    if (nextProps.chosenDate && this.state.startDate !== nextProps.chosenDate.date) {
      this.setState({ startDate: nextProps.chosenDate.date, numDays: 0 })
    }
  }

  updateState(data) {
    this.setState(data)
  }

  getAmountOfPeople() {
    const { partySize, travelers } = this.state
    return partySize ? partySize + 1 : travelers.length + 1
  }

  getTotalAmount() {
    const { privateTour } = this.state
    const { data } = this.props
    const localTour = _.head(data.allLocalTours)
    let price = privateTour ? localTour.privateTourPrice : localTour.groupPrice
    let totalAmount = privateTour ? localTour.privateTourPrice : price * this.getAmountOfPeople()
    return totalAmount
  }      

  getTotalAmountWithFee() {
    let totalAmount = this.getTotalAmount() * (1 + config.activityServiceFee)
    return totalAmount
  }      

  saveBookingSteps(transaction) {
    const { partySize, privateTour, travelers } = this.state
    const { data, chosenDate } = this.props
    const amountOfPeople = this.getAmountOfPeople()
    const localTour = _.head(data.allLocalTours)

    let travelersWithoutAge = this.state.travelers.map(traveler => {
      return { name: traveler.name, yearOfBirth: traveler.yearOfBirth }
    })

    let totalAmount = this.getTotalAmount()

    this.setState(
      {
        localTourId: localTour.id,
        travelers: travelersWithoutAge,
        price: totalAmount,
        userId: this.user.id,
        bookingDate: chosenDate.date,
        paymentTransactionId: transaction.dbId
      },
      () => {
        this.props.createTourBooking({ variables: this.state })
      }
    )
  }

  render() {
    console.log('parent props', this.props)
    const { user, data, t } = this.props

    if (!data.allLocalTours) {
      return <Loading />
    } else {
      this.steps = [
        {
          name: 'Set Travelers',
          component: <SetTravelers user={user} data={data} currentState={this.state} updateState={this.updateState.bind(this)} />
        },
        {
          name: 'Review and Pay',
          component: (
            <ReviewPay currentState={this.state} updateState={this.updateState.bind(this)} saveBookingSteps={(transaction) => this.saveBookingSteps(transaction)} amountToPay={this.getTotalAmountWithFee()}/>
          )
        }
      ]
      return (
        <div className="booking-steps">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-7 main-info">
                <div className="header">
                  <span>{_.head(data.allLocalTours).title}</span>
                </div>

                <div className="step-progress wizard">
                  <StepZilla
                    steps={this.steps}
                    showSteps={true}
                    showNavigation={false}
                    stepsNavigation={!!this.state.travelingType}
                    prevBtnOnLastStep={true}
                    dontValidate={false}
                    preventEnterSubmission={false}
                    startAtStep={0}
                    backButtonText={t('back')}
                    nextButtonText={t('next')}
                    nextTextOnFinalActionStep={t('next')}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-5 col-sm-5">
                <BookingSummary
                  summary={this.state}
                  activity={_.head(data.allLocalTours)}
                  user={user}
                  updateState={this.updateState.bind(this)}
                  saveBookingSteps={() => this.saveBookingSteps()}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

const enhance = compose(
  translate('activity_booking_steps'),
  graphql(CREATE_BOOKING_QUERY, { name: 'createTourBooking' }),
  graphql(USER_QUERY, {
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  graphql(LOCAL_TOUR_QUERY, {
    options: props => ({
      variables: {
        id: props.match.params.id
      },
      fetchPolicy: 'network-only'
    })
  })
)

export default enhance(ActivityBookingSteps)



// WEBPACK FOOTER //
// src/components/Activity/ActivityBookingSteps.jsx